
// ROUTES
require('modules/invitation-transfer/routes/invitation-transfer');

// CONTROLLERS
require('modules/invitation-transfer/controllers/invitation-transfer');
require('modules/invitation-transfer/controllers/list');
require('modules/invitation-transfer/controllers/create');
require('modules/invitation-transfer/controllers/edit');

// SERVICES
require('modules/invitation-transfer/services/invitation-transfer');
require('modules/invitation-transfer/services/list');
require('modules/invitation-transfer/services/create');
require('modules/invitation-transfer/services/edit');
require('modules/invitation-transfer/services/delete');


angular.module('unica_invitation_transfer', [

	// ROUTES
	'unica_invitation_transfer.invitation_transfer_routes',

	// CONTROLLERS
	'unica_invitation_transfer.invitation_transfer_controllers',

	// SERVICES
	'unica_invitation_transfer.invitation_transfer_services'

]);